import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["line", "dot", "tooltip", "value", "label"]
  static values = { months: Array }

  move(event) {
    const index = this.monthIndex(event)
    this.renderTooltip(index)
    this.positionLine(index)
    this.positionDot(index)
    this.positionTooltip(index)
  }

  hide() {
    this.lineTarget.classList.add("hidden")
    this.dotTarget.classList.add("hidden")
    this.tooltipTarget.classList.add("hidden")
  }

  monthIndex(event) {
    const rect = this.element.getBoundingClientRect()
    const ratio = (event.clientX - rect.left) / rect.width
    return Math.max(0, Math.min(this.lastIndex, Math.round(ratio * this.lastIndex)))
  }

  renderTooltip(index) {
    const month = this.monthsValue[index]
    this.valueTarget.textContent = month.value
    this.labelTarget.textContent = month.label
  }

  positionLine(index) {
    this.lineTarget.style.left = `${Math.min(this.xFor(index), this.element.clientWidth - 1)}px`
    this.lineTarget.classList.remove("hidden")
  }

  positionDot(index) {
    const month = this.monthsValue[index]
    if (month.y === null) return this.dotTarget.classList.add("hidden")

    this.dotTarget.style.left = `${this.xFor(index)}px`
    this.dotTarget.style.top = `${month.y}%`
    this.dotTarget.classList.remove("hidden")
  }

  positionTooltip(index) {
    const tooltip = this.tooltipTarget
    tooltip.classList.remove("hidden")
    const centred = this.xFor(index) - tooltip.offsetWidth / 2
    tooltip.style.left = `${Math.max(0, Math.min(centred, this.element.clientWidth - tooltip.offsetWidth))}px`
  }

  xFor(index) {
    if (this.lastIndex === 0) return this.element.clientWidth
    return (index / this.lastIndex) * this.element.clientWidth
  }

  get lastIndex() {
    return this.monthsValue.length - 1
  }
}
